import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgAwardOutlined = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-award"
    viewBox="-.5 -.5 16 16"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    {desc === undefined ? (
      <desc id={descId}>
        {"\n    Award Streamline Icon: https://streamlinehq.com\n  "}
      </desc>
    ) : desc ? (
      <desc id={descId}>{desc}</desc>
    ) : null}
    <path d="M3.4552 5.1887c0 3.1137 3.3707 5.0597 6.0672 3.5029a4.045 4.045 0 0 0 2.0224-3.503c0-3.1136-3.3707-5.0597-6.0672-3.5028a4.045 4.045 0 0 0-2.0224 3.5029" />
    <path d="m5.31 8.5921-.6991 5.264L7.5 12.1226l2.8891 1.7335L9.69 8.5863" />
  </svg>
);
export default SvgAwardOutlined;
